export const SPACE_ROLES_KEY = 'spaceRoles';
export const getSpaceRolesKey = (args) => [
    SPACE_ROLES_KEY,
    args,
];
//# sourceMappingURL=spaceRoles.key.js.map